<template>
    <Button
        buttonClass="delete"
        text="Annuleren"
        @click="confirmCancel"
        v-if="request.status !== 'cancelled' && request.status !== 'reported'
            && this.$page.props.user.permissions.includes('requests.cancel')"
    />
    <Modal
        visible="hidden"
        modalClass="w-1/2"
        ref="modalCreditNoteNeeded"
    >
        Moet er een creditnota worden opgemaakt?
        <div class="mt-2 mb-4">
            <Button
                text="Ja"
                @click="createCreditNote"
            />
            <Button
                text="Nee"
                @click="cancelRequest"
            />
        </div>
    </Modal>
</template>

<script>
import Button from '@/Components/Button.vue'
import Modal from '@/Components/Modal.vue'

import {Inertia} from "@inertiajs/inertia";
import {ref} from "vue";

export default {
    components: {
        Button,
        Modal,
    },
    props: {
        request: {
            required: true
        },
    },
    emits: ['createRequestCreditNote'],
    setup(props, {emit}) {
        let modalCreditNoteNeeded = ref(null)

        function confirmCancel(event)
        {
            if (!confirm('Bent u zeker dat u deze aanvraag wil annuleren?'))
                return

            modalCreditNoteNeeded.value.show = true
        }

        function createCreditNote()
        {
            modalCreditNoteNeeded.value.show = false
            emit('createRequestCreditNote', true)//Passing true, will cancel the request
        }

        function cancelRequest()
        {
            Inertia.post(route('requests.cancel-request', { 'request': props.request.id }))
        }

        return {
            modalCreditNoteNeeded,
            createCreditNote,
            confirmCancel,
            cancelRequest,
        }
    }
}
</script>
